import React from 'react';

import { Field, FieldProps } from 'formik';

import { useGetMyCompanyQuery } from '../../../../../api/company';
import { useMeQuery } from '../../../../../api/user';
import { FormikDropdown } from '../../../../../shared/components/formik-dropdown';
import { ProductsCategories } from '../../../../../shared/constants/products';
import { getCategoriesFromIds } from '../../../../../shared/helpers/getCategoryId';

import classes from './style.module.scss';

export const CategoryDropdown: React.FC = () => {
  const { data: user } = useMeQuery();
  const { data: company } = useGetMyCompanyQuery(user?.company?.id, {
    skip: !user?.company.id,
  });

  return (
    <div className={classes.form}>
      <Field name='category'>
        {(fieldProps: FieldProps) => (
          <FormikDropdown
            label='What do you buy from this supplier?'
            placeholder='Select category'
            options={(company?.categories.length ? getCategoriesFromIds(company?.categories) : Object.values(ProductsCategories)).map(
              (cat) => ({
                label: cat,
                value: cat,
              }),
            )}
            {...fieldProps}
            customClasses={{
              customSelectClass: '',
              customFormControlClass: '',
              placeholderClass: classes.customPlaceholder,
            }}
          />
        )}
      </Field>
    </div>
  );
};
